import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import store from "../../../store/store";
import ErrorPopup from "../../../components/dialogBox/errorModal";
import SuccessDialog from "../../../components/dialogBox/successDialog";
import RateContractWizard from "./RateContractWizard/rateContractWizard";
import { createRateContract } from "../../../store/api/rateContract";
import { PAGES_URL } from "../../../shared/constants/constants";

const RateContract = () => {
  const navigate = useNavigate();
  const [success, setSuccess] = useState({
    open: false,
    message: "",
    navigatePath: "",
  });
  const [error, setError] = useState({ open: false, message: "" });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const location = useLocation();
  const orderId = location.state && location.state.orderId;
  const isEdit = location.state && location.state.isEdit;
  const [orderDetails, setOrderDetails] = useState<any>();

  // useEffect(() => {
  //   if (isEdit) {
  //     store
  //       .dispatch(getOrderDetails(orderId))
  //       .unwrap()
  //       .then((resp) => {
  //         setOrderDetails(resp.data);
  //       })
  //       .catch((error: any) => {
  //         setError({ open: true, message: error });
  //       });
  //   }
  // }, [orderId, isEdit]);

  const handleCloseSuccess = () => {
    setSuccess({ ...success, open: false });
    navigate(success.navigatePath || "/dashboard");
  };

  const handleCloseError = () => {
    setError({ ...error, open: false });
  };

  const handleCreateContract = (
    resquestType: string,
    contractRequestBody?: any
  ) => {
    setIsLoading(true);
    console.log("contractRequestBody :: ", contractRequestBody);
    store
      .dispatch(createRateContract(contractRequestBody))
      .unwrap()
      .then((res: any) => {
        console.log(res);
        setSuccess({
          open: true,
          message: "Contract created successfully.",
          navigatePath: `${PAGES_URL.ORDERMGR}/${PAGES_URL.RATE_CONTRACT_LIST}`,
        });
      })
      .catch((err) => {
        setError({
          open: true,
          message: err,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Box display={"flex"} flex={1}>
      <RateContractWizard
        isEdit={isEdit}
        handleCreateContract={handleCreateContract}
        isLoading={isLoading}
      />

      <ErrorPopup
        open={error.open}
        message={error.message}
        onClose={handleCloseError}
      />
      <SuccessDialog
        open={success.open}
        message={success.message}
        onClose={handleCloseSuccess}
      />
    </Box>
  );
};

export default RateContract;
